import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

interface BlitzExportRequest {
	ruleIds?: string[];
	onlyActive?: boolean;
	onlyEnabled?: boolean;
}

interface UseExportBlitzesMutationOptions {
	onSuccess?: (systemJob: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
}

/**
 * Hook to export blitzes to CSV
 *
 * @param param.onSuccess [optional] Callback function to be called when the mutation is successful.
 * @param param.onError [optional] Callback function to be called when the mutation fails.
 * @returns Mutation hook for exporting blitzes
 */
export function useExportBlitzesMutation({ onSuccess, onError }: UseExportBlitzesMutationOptions = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: BlitzExportRequest = {}) => {
			return userSession.webServiceHelper.callAsync<Api.ISystemJob>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'aida/rule/export',
				}),
				'POST',
				request
			);
		},
		onSuccess,
		onError,
	});
}
